<template>
  <form
    v-if="!passwordResetEmailSent"
    class="grid gap-20 box box-padding bg-white"
    @submit.prevent="submit"
  >
    <div
      v-if="passwordResetError"
      class="mb-20 bg-red-light text-red p-10 text-base font-normal"
    >
      {{ passwordResetError }}
    </div>

    <FormKitPharmasuisseUser v-model="username" />
    <div class="buttons col-span-full">
      <input
        type="submit"
        class="button is-primary"
        :value="$texts('passwordReset', 'Passwort zurücksetzen')"
        :class="{ 'is-loading': isLoading }"
      />
      <NuxtLink :to="loginRoute" class="button is-white">
        {{ $texts('returnToLogin', 'Zurück zum Login') }}
      </NuxtLink>
    </div>
  </form>
  <div v-else class="grid gap-20">
    <div>
      {{
        $texts(
          'passwordResetSent',
          'Eine E-Mail mit weiteren Anweisungen wurde an den angegebenen Benutzer gesendet.',
        )
      }}
    </div>

    <NuxtLink :to="loginRoute" class="button is-white">
      {{ $texts('returnToLogin', 'Zurück zum Login') }}
    </NuxtLink>
  </div>
</template>

<script lang="ts" setup>
await initFormKit()

const { $texts } = useNuxtApp()
const route = useRoute()
const language = useCurrentLanguage()

const username = ref('')
const passwordResetError = ref('')
const isLoading = ref(false)
const passwordResetEmailSent = ref(false)

const loginRoute = computed(() => `/${language.value}/user/login`)

if (route.query.error) {
  passwordResetError.value = route.query.error as string
}

onMounted(() => {
  if (route.query.user && typeof route.query.user === 'string') {
    username.value = route.query.user
    return
  }
  // Load the initial value in case the model wasn't updated by browser autofill.
  username.value =
    (document.querySelector('#username') as HTMLInputElement)?.value || ''
})

function submit() {
  if (isLoading.value) {
    return
  }
  isLoading.value = true
  useGraphqlMutation('userPasswordReset', {
    value: username.value,
  })
    .then((v) => {
      isLoading.value = false

      // Check if request was successful.
      if (v.data.userPasswordReset?.success) {
        passwordResetEmailSent.value = true
        return
      }

      // Handle password reset errors. We should be receiving a message here.
      // If not, throw an error which will show a generic error message.
      if (!v.data.userPasswordReset?.error) {
        throw new Error('Unexpected error')
      }

      passwordResetError.value = v.data.userPasswordReset?.error
    })
    .catch(() => {
      isLoading.value = false
      // Show a generic error. This should only happen when Drupal is down or
      // throws a fatal.
      passwordResetError.value = $texts(
        'passwordResetError',
        'Unerwarteter Fehler. Bitte versuchen Sie es noch einmal oder kontaktieren Sie uns.',
      )
    })
}
</script>
